// extracted by mini-css-extract-plugin
module.exports = {"CheckBoxInput":"CheckBox_CheckBoxInput__zcEgI","GrayCheckBoxInput":"CheckBox_GrayCheckBoxInput__2y9ph","CheckBox":"CheckBox_CheckBox__1GrIM","Text":"CheckBox_Text__x5YdX"};